(() => {
  const modalId = 'RtmSpecialRequestModal';
  let lastFocusedElement = null;

  const getModal = () => document.getElementById(modalId);
  const getTriggers = () => document.querySelectorAll('[data-special-request-open]');

  function setTriggerState(isOpen) {
    getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', String(isOpen)));
  }

  function closeNavigationDrawer() {
    document.querySelectorAll('header-drawer details[open]').forEach((details) => details.removeAttribute('open'));
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
  }

  function openSpecialRequest(trigger) {
    const modal = getModal();
    if (!modal) return;

    lastFocusedElement = trigger || document.activeElement;
    closeNavigationDrawer();
    modal.hidden = false;
    document.body.classList.add('rtm-special-request-open');
    setTriggerState(true);

    window.requestAnimationFrame(() => {
      modal.querySelector('[data-special-request-title]')?.focus();
    });
  }

  function closeSpecialRequest() {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.body.classList.remove('rtm-special-request-open');
    setTriggerState(false);

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function trapFocus(event, modal) {
    if (event.key !== 'Tab') return;

    const focusable = [...modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), textarea:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.offsetParent !== null);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-special-request-open]');
    if (trigger) {
      event.preventDefault();
      openSpecialRequest(trigger);
      return;
    }

    const modal = getModal();
    if (!modal || modal.hidden) return;

    if (event.target.closest('[data-special-request-close]') || event.target === modal) {
      event.preventDefault();
      closeSpecialRequest();
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeSpecialRequest();
      return;
    }

    trapFocus(event, modal);
  });

  function initializeSpecialRequest() {
    const modal = getModal();
    if (!modal) return;

    getTriggers().forEach((trigger) => {
      trigger.setAttribute('aria-controls', modalId);
      trigger.setAttribute('aria-expanded', 'false');
    });

    if (modal.querySelector('[data-special-request-success], [data-special-request-error]')) {
      openSpecialRequest();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSpecialRequest, { once: true });
  } else {
    initializeSpecialRequest();
  }

  document.addEventListener('shopify:section:load', initializeSpecialRequest);
})();
